import React from "react";
import {Icon, ProcessStateListCell} from "gd-react";
import {isScheduleRequest} from "../../../services/dataRequestTypes";

// A schedule rests at SCHEDULED, which ProcessStateListCell would render as a permanent spinner.
class DataRequestStatusCell extends React.Component {
    render() {
        if (!isScheduleRequest(this.props.object)) {
            return <ProcessStateListCell {...this.props}/>;
        }
        const active = this.props.object.active !== false;
        return (
            <div className={"list-field process-state-list-cell " + (this.props.noheader ? 'checkbox' : '')}
                 title={active ? 'Schedule is active' : 'Schedule is paused'}
                 style={{maxWidth: this.props.maxWidth ? this.props.maxWidth : '250px'}}>
                <Icon size={'18'}
                      color={active ? 'gd-green' : 'gd-grey'}
                      icon={active ? 'FaCircle' : 'FaPauseCircle'}/>
            </div>
        );
    }
}

export default DataRequestStatusCell;
